import React from 'react';
import { Button } from 'antd';
import { withRouter } from 'react-router-dom';
import {
  DownloadOutlined,
  PushpinOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { saveAs } from 'file-saver';
import axios from 'axios';
import firebase from 'firebase';
import KakaoShareBtn from '../../../utils/KakaoShareBtn';

function ZzalInfo(props) {
  const user = useSelector((state) => state.user);

  const addZzalHandler = () => {
    if (!user.isLogin) {
      alert('로그인 후 이용 가능합니다.');
      props.history.push('/login');
    } else {
      firebase
        .database()
        .ref('zzals/' + localStorage.getItem('u_id'))
        .push()
        .set(props.info)
        .then((doc) => {
          alert('내 짤주머니에 저장!');
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const downloadHandler = () => {
    const data = new FormData();
    data.append('file', props.info.link);
    data.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET);
    data.append('cloud_name', process.env.REACT_APP_CLOUD_NAME);
    fetch(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
      {
        method: 'post',
        body: data,
      }
    )
      .then((resp) => resp.json())
      .then((temp) => {
        let url = temp.url.substring(5);
        axios
          .get(url, {
            responseType: 'blob',
          })
          .then((res) => saveAs(res.data, 'zzal.png'))
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  };

  const onKakaoShare = () => {
    const data = new FormData();
    data.append('file', props.info.link);
    data.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET);
    data.append('cloud_name', process.env.REACT_APP_CLOUD_NAME);
    fetch(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
      {
        method: 'post',
        body: data,
      }
    )
      .then((resp) => resp.json())
      .then((temp) => {
        const { Kakao } = window;
        Kakao.Link.sendDefault({
          objectType: 'feed',
          content: {
            title: '내 짤을 받아랏',
            description: '#짤방 #짤해 #커스텀짤 #짤생성',
            imageUrl: temp.url,
            link: {
              webUrl: 'https://zzal-debug.web.app/',
              mobileWebUrl: 'https://zzal-debug.web.app/',
            },
          },
          buttons: [
            {
              title: '더 많은 짤을 찾아..',
              link: {
                webUrl: 'https://zzal-debug.web.app/',
                mobileWebUrl: 'https://zzal-debug.web.app/',
              },
            },
          ],
        });
      })
      .catch((err) => console.log(err));
  };

  return (
    <div style={{ marginTop: '3rem' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Button
          type='primary'
          shape='round'
          icon={<DownloadOutlined />}
          size='large'
          onClick={downloadHandler}
          style={{ marginRight: '1.5rem' }}
        >
          다운로드
        </Button>
        {user && user.isLogin ? (
          <Button
            type='primary'
            shape='round'
            icon={<PushpinOutlined />}
            size='large'
            onClick={addZzalHandler}
          >
            내짤하기
          </Button>
        ) : (
          <Button
            type='primary'
            shape='round'
            size='large'
            onClick={() => {
              props.history.push('/login');
            }}
          >
            로그인해서 나만의 짤을 모아보자!
          </Button>
        )}
      </div>
      <div style={{ marginTop: '3rem' }}>
        <Button
          icon={<EditOutlined />}
          size='large'
          onClick={() => {
            props.history.push({
              pathname: `/edit/${props.info.id}`,
              state: {
                link: props.info.link,
              },
            });
          }}
          style={{ width: '300px' }}
        >
          수정하기
        </Button>
      </div>
      <KakaoShareBtn onClick={onKakaoShare} />
    </div>
  );
}

export default withRouter(ZzalInfo);
